export default __webpack_public_path__ + "static/media/thumb-2.eaf1d670.png";